import {
  FETCH_PROCEDURELIST_REQUEST,
  FETCH_PROCEDURELIST_SUCCESS,
  FETCH_PROCEDURELIST_FAILURE,
} from "./procedureListTypes";

const initialState = {
  loading: false,
  procedureList: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROCEDURELIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_PROCEDURELIST_SUCCESS:
      return {
        loading: false,
        procedureList: action.payload,
        error: "",
      };
    case FETCH_PROCEDURELIST_FAILURE:
      return {
        loading: false,
        procedureList: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
